<template>
	<div v-if="!!visible || visible != false" id="header-component">
		<div class="field-container">
			
			<div v-for="field in header.fields" :key="field.name" :id="field.name" 
				@click="fieldOnClick(field, $event)" :class="{'invalid':field.invalid}">
				<div class="field" v-if="field.type=='date'" >
					<input type="month" v-model="header.data[field.name]" :placeholder="$t('month')" />
				</div>
				<v-select
					class="field"
					v-model="header.data[field.name]"
					:options="field.options"
					:label="field.selectLabel || 'label'"
					:value="field.selectValue || 'value'"
					:placeholder="field.label"
					@input="selectOnInput(field, $event)"
					v-if="field.type=='select'"
				><span slot="no-options">{{field.noOptionsText}}</span></v-select>
				<div class="field button" v-if="field.type=='button'" >
					{{field.label}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Util from '@/application/libs/util';
import eventModule from '@/application/libs/eventModule';
import moment from 'moment';
import DefaultHeaderController from '../controllers/DefaultHeaderController';
import InitialForm from '@/components/src/InitialForm';
import { t } from 'i18next';
const defaultNoOptionsText = "Nenhum dado encontrado.";
const noOptionsText = defaultNoOptionsText;

export default {
	name: "DefaultHeaderComponent",
	props:["visible"],
	components: {
		"v-select": VueSelect
	},
	created(){
		if(!this.boDataEventListenerBinded){
			eventModule.$on('updateBoData', this.onUpdateBoData);
			this.boDataEventListenerBinded = true;
		}
	},
	beforeDestroy(){
		eventModule.$off('updateBoData', this.onUpdateBoData);
		this.boDataEventListenerBinded = false;
	},
	mounted(){
		let unitField = this.header.fields.find(f=>f.name=="unit");
		DefaultHeaderController.getUnitData(unitField,{
			CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR
		});

		let serviceField = this.header.fields.find(f=>f.name=="service");
		unitField.onInput = ()=>{
			this.header.data.service = null;
			this.loadServicesIntoField();
		};

		DefaultHeaderController.getServiceData(serviceField,{
			CDFILIAL: (Util.getFilterInSession() || {}).CDFILIAL
		});

		let submitBut = this.header.fields.find(f=>f.name=="submit");
		submitBut.onClick = function(){
			DefaultHeaderController.saveIfIsValid(this);
		}.bind(this);
		if(!Util.getFilterInSession().CDFILIAL){
			this.$modal.show(InitialForm, {}, {
				height:'auto',
				clickToClose: false
			});
		}
	},
	data() {
		return {
			header: {
				fields: [
					{
						name: "cardDate",
						type: "date",
						invalid: false
					},
					{
						name: "contract",
						type: "select",
						label: t('type_contract'),
						selectLabel:'NMCONTRATO',
						options:[
							{TPCONTRATO:'CONTRATO', NMCONTRATO: t('contract')},
							{TPCONTRATO:'PLANEJADO', NMCONTRATO: t('planned')}
						],
						invalid: false,
						noOptionsText
					},
					{
						name: "unit",
						type: "select",
						label: t('unit'),
						selectLabel:'NMFILIAL',
						options:[],
						invalid: false,
						noOptionsText
					},
					{
						name: "service",
						type: "select",
						label: t('service'),
						selectLabel: 'NMSERVICO',
						options: [],
						invalid: false,
						noOptionsText
					},
					{
						name: "submit",
						type: "button",
						label: t('apply')
					}
				],
				data: {
					cardDate: Util.getFilterInSession().DTMESCARD ?  
						moment(Util.getFilterInSession().DTMESCARD, 'DD/MM/YYYY').format('YYYY-MM')
						: '',

					contract: Util.getFilterInSession().TPCONTRATO ? {
						TPCONTRATO:Util.getFilterInSession().TPCONTRATO,
						NMCONTRATO:Util.getFilterInSession().NMCONTRATO
					} : '',

					unit: Util.getFilterInSession().CDFILIAL ? {
						CDFILIAL:Util.getFilterInSession().CDFILIAL,
						NMFILIAL:Util.getFilterInSession().NMFILIAL
					} : '',

					service:Util.getFilterInSession().CDSERVFILI ? {
						CDSERVFILI:Util.getFilterInSession().CDSERVFILI,
						NMSERVICO:Util.getFilterInSession().NMSERVICO
					} : ''
				}
			}
		};
	},
	methods:{
		fieldOnClick(field, event){
			if(field.onClick){
				field.onClick(event)
			}
		},
		selectOnInput(field, $event){
			if(field.onInput){
				field.onInput(event)
			}
		},
		loadServicesIntoField(){
			let serviceField = this.header.fields.find(f=>f.name=="service");
			if(this.header.data.unit && this.header.data.unit.CDFILIAL){
				DefaultHeaderController.getServiceData(serviceField,{
					CDFILIAL: this.header.data.unit.CDFILIAL
				});
			}
		},
		onUpdateBoData(){
			this.header.data.cardDate= moment(Util.getFilterInSession().DTMESCARD, 'DD/MM/YYYY').format('YYYY-MM');

			this.header.data.contract= {
				TPCONTRATO:Util.getFilterInSession().TPCONTRATO,
				NMCONTRATO:Util.getFilterInSession().NMCONTRATO
			};

			this.header.data.unit= {
				CDFILIAL:Util.getFilterInSession().CDFILIAL,
				NMFILIAL:Util.getFilterInSession().NMFILIAL
			};

			this.loadServicesIntoField();

			this.header.data.service = {
				CDSERVFILI:Util.getFilterInSession().CDSERVFILI,
				NMSERVICO:Util.getFilterInSession().NMSERVICO
			};
		},
	}
};
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

#header-component {
	background: linear-gradient(160deg, #22224b 0%, #1d265f 100%);
	width: 100%;
	min-height: 48px;
	height: auto;
	padding: 8px;
	box-shadow: 0 8px 20px rgba(9, 13, 35, 0.2);

	.field-container{
		display: flex;
		gap: 8px;
		align-items: stretch;
		width: 98%;
		flex-wrap: nowrap;

		&>div{
			margin: 0;
			display: inline-flex;
			flex:1;
			min-width: 0;
			max-width: 22%;
			height: 38px;

			&.invalid{
				.field{
					border: 2px solid #ff4f6e;
				}
			}
		}

		
		.field{
			height:100%;
			width: 100%;
			font-size: 0.9rem;
			font-weight: 500;

			box-sizing: border-box;
			border-radius: 9px;
			text-align: left;
			background-color: #ffffff;
			border: 0px;
			padding: 0 10px;
			color: #202a4d;
			transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;

			&:focus,
			&:focus-within {
				border-color: rgba(54, 84, 190, 0.7);
				box-shadow: 0 0 0 2px rgba(54, 84, 190, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.5);
			}

			&.button{
				background: linear-gradient(160deg, #e24158 0%, #bc2842 100%);
				padding: 8px 0;
				text-align: center;
				color: white;
				font-weight: 600;
				letter-spacing: 0.01em;
				cursor: pointer;
				border: 1px solid rgba(255, 255, 255, 0.28);
				box-shadow: 0 4px 12px rgba(188, 40, 66, 0.34);
				transition: filter 0.16s ease, transform 0.16s ease, box-shadow 0.16s ease;

				&:hover{
					filter: brightness(1.08);
					transform: translateY(-1px);
					box-shadow: 0 6px 14px rgba(188, 40, 66, 0.4);
				}
			}
		}

		// .v-select.field{
		// 	.field;

		// 	.vs__dropdown-toggle{
		// 		height: 100%;
		// 		overflow:hidden;
		// 	}
		// }

		.v-select.field{
			font-size: 0.9rem;

			.vs__selected-options {
			flex-wrap: nowrap;
			max-width: calc(100% - 41px);
			padding-left: 4px;
			}

			.vs__selected {
				display: block;
				white-space: nowrap;
				text-overflow: ellipsis;
				max-width: 100%;
				overflow: hidden;
			}

			// .vs__search {
			// 	position: absolute;
			// }

			// .vs--open .vs__search {
			// 	position: static;
			// }
			
			.vs__dropdown-menu{
				width: max-content;
				max-width: 75vw;
			}

			.vs__dropdown-toggle{
				height: 100%;
				border: 1px solid transparent;
				padding: 0 6px;
				border-radius: 9px;
				background: #ffffff;
			}

			.vs__dropdown-option {
			white-space: normal;
			}
		}
		.v-select.field.vs--searching{
			.vs__selected {
				display: none;
			}
		}
		input[type="month"], input[type="date"]{
			.field;
			display: block;
			position: relative;
			line-height: 34px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			padding-right: 30px;
	
			&:before {
				content: attr(placeholder)+': ' !important;
				font-family: inherit;
				font-size: 0.8rem;
				font-weight: 600;
				text-transform: uppercase;
				color: #44507f;
				display: block;
				position: absolute;
				left: 10px;
				top: 50%;
				transform: translateY(-50%);
				pointer-events: none;
				white-space: nowrap;
				margin: 0;
			}
	
			&::-webkit-datetime-edit {
				font-family: inherit;
				font-size: 0.84rem;
				color: #1f2a52;
				padding-left: 56px;
				display: inline-block;
				white-space: nowrap;
			}
	
			&::-webkit-calendar-picker-indicator {
				position: absolute;
				right: 8px;
				top: 50%;
				transform: translateY(-50%);
				margin: 0;
				cursor: pointer;
			}

			&::-webkit-inner-spin-button{
				position:relative;
				top: 0;
			}
		}
	}

		@media (max-width: 1366px){
			.field-container{
				gap: 6px;

				&>div{
					flex: 1 1 calc(33.33% - 4px);
					max-width: none;
				}
			}
		}

		@media (max-width: 900px){
			padding: 7px;

			.field-container{
				flex-wrap: wrap;
				&>div{
					flex: 1 1 calc(50% - 3px);
					max-width: none;
					height: 36px;
				}

				.field{
					font-size: 0.83rem;
				}
			}
		}

	@media (max-width: 640px){
		.field-container{
			&>div{
				max-width: 100%;
				flex: 1 1 100%;
			}
		}
	}
}
</style>
